import { UpsellServiceAvailableOffer } from '@types/upsellServiceAvailableOffer';

export const INSURANCE_CONTACT_TYPES = {
	FIRST_CONTACT: 'FIRST_CONTACT',
	REMINDER: 'REMINDER',
	LAST_CHANCE: 'LAST_CHANCE',
} as const;

export type InsuranceContactType =
	(typeof INSURANCE_CONTACT_TYPES)[keyof typeof INSURANCE_CONTACT_TYPES];

export const MONTH_KEY_FORMAT = 'yyyy-MM';

export interface InsuranceOfferMemory {
	contacted: Record<string, string>;
	lastMonthlyMessageMonth: string | null;
}

export interface InsuranceContactSelection {
	contactType: InsuranceContactType;
	purchases: UpsellServiceAvailableOffer[];
}
